import { render } from "./VisitDashboard.vue?vue&type=template&id=ee68731e&scoped=true"
import script from "./VisitDashboard.vue?vue&type=script&lang=js"
export * from "./VisitDashboard.vue?vue&type=script&lang=js"

import "./VisitDashboard.vue?vue&type=style&index=0&id=ee68731e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee68731e"]])

export default __exports__